import { useRouter } from "next/router";
import RecipeKioskLayout from "@Components/layout/RecipeKioskLayout";
import { RecipesListing } from "@Components/recipes-listing/RecipesListing";
import {
  RecipeHero,
  RecipeListCard,
  RecipeListFilter,
  RecipeSearchInput,
  RecipeLoadMoreButton,
} from "@Components/recipes-listing/components";
import { KIOSK_VIEW_MODE_QUERY } from "@Constants/url";
import CmsPage, { getCMSPageModel } from "@Libs/contentful/components/CmsPage";
import RecipesListingPageQuery from "@Libs/contentful/queries/RecipesListingPage";
import { makeStaticProps } from "@Libs/i18n/getStatic";
import { pageModel } from "@Types/Contentful";
import { IRecipesListingPageContent } from "@Types/recipes-listing-page";
import { RecipesContextProvider } from "@wff/context/recipes/RecipesContextProvider";
import { useRecipePagination } from "@wff/hooks/useRecipePagination";
import { getStaticPaths } from "../../../../libs/i18n/getStatic";

interface RecipesListingPageProps {
  pageModel: pageModel;
}

const RecipesListingPage = ({ pageModel }: RecipesListingPageProps) => {
  const {
    query: { viewMode },
  } = useRouter();
  const { pageContent = {} } = pageModel;
  const useRecipesProp = useRecipePagination();

  // The kiosk in the O2O store view mode
  if (viewMode === KIOSK_VIEW_MODE_QUERY) {
    return (
      <RecipesContextProvider
        {...useRecipesProp}
        contenfulContent={pageContent as IRecipesListingPageContent}
      >
        <RecipeKioskLayout
          pageModel={pageModel}
          pageTitle={pageContent.pageTitle}
          rightHeaderContent={<RecipeSearchInput />}
          pageDescription={pageContent.pageDescription}
        >
          <RecipesListing>
            <RecipeHero />
            <RecipeListFilter />
            <RecipeListCard />
            <RecipeLoadMoreButton />
          </RecipesListing>
        </RecipeKioskLayout>
      </RecipesContextProvider>
    );
  }

  return (
    <CmsPage
      pageModel={pageModel}
      pageTitle={pageContent.pageTitle ?? ""}
      pageDescription={pageContent.pageDescription ?? ""}
    >
      <RecipesContextProvider
        {...useRecipesProp}
        contenfulContent={pageContent as IRecipesListingPageContent}
      >
        <RecipesListing>
          <RecipeHero />
          <RecipeSearchInput />
          <RecipeListCard />
          <RecipeLoadMoreButton />
        </RecipesListing>
      </RecipesContextProvider>
    </CmsPage>
  );
};

const overrideStaticProps = async (props: any) => {
  const { locale } = props;

  const pageModel = await getCMSPageModel(RecipesListingPageQuery, {
    locale,
  });

  return {
    props: {
      pageModel,
    },
  };
};

const getStaticProps = makeStaticProps(["common"], overrideStaticProps);
export { getStaticPaths, getStaticProps };

export default RecipesListingPage;
